// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3Eo-i","ranges":"BmiRanges_ranges__2Sigp"};